import { jsx as a, jsxs as f } from "react/jsx-runtime";
import { useMemo as i, useEffect as p } from "react";
import { c as h } from "../../index-C7ezJk5b.js";
import { b as d, R as e } from "../../base-BUIxijjU.js";
import { startsFromInLC as P, equalInLC as C } from "../../core/utils/string.js";
import { cssX as R } from "../../core/utils/css.js";
import g from "../../components/Popup/Popup.js";
import '../../assets/Wrapper.css';/* empty css                     */
import "react-dom";
import "react-router-dom";
import { usePlatformSearch as b } from "../../api/usePlatformSearch.js";
import D from "./GlobalSearchHeader.js";
import I from "./GlobalSearchResults.js";
const N = () => {
  const { globalSearch: {
    isOpened: s,
    setIsOpened: l,
    setQuery: n,
    query: r
  } } = d(), { data: t, isLoading: m } = b(s), c = i(
    () => ([
      ...t[e.FoodProfiles].items,
      ...t[e.MacInstantCharts].items,
      ...t[e.ChainProfiles].items,
      ...t[e.ReportProDocuments].items,
      ...t[e.MyDocsDocuments].items
    ].map((o) => o.title).find((o) => P(o, r) && !C(o, r)) || "").trim(),
    [t, r]
  ), u = i(
    () => !m && (t[e.FoodProfiles].items.length > 0 || t[e.MacInstantCharts].items.length > 0 || t[e.ChainProfiles].items.length > 0 || t[e.ReportProDocuments].items.length > 0 || t[e.MyDocsDocuments].items.length > 0 || t.chainsInMenuCount > 0),
    [m, t]
  );
  return p(() => {
    s || n("");
  }, [s]), /* @__PURE__ */ a(
    g,
    {
      isOpened: s,
      close: () => l(!1),
      closeOnEsc: !0,
      children: /* @__PURE__ */ f("div", { className: h(R("GlobalSearch")), children: [
        /* @__PURE__ */ a(D, { autocomplete: c, hasResults: u }),
        /* @__PURE__ */ a(
          I,
          {
            data: t,
            isLoading: m
          }
        )
      ] })
    }
  );
};
export {
  N as default
};
